export { default } from './CategorySectionList';



// WEBPACK FOOTER //
// ./src/components/categories/CategorySectionList/index.js